export const sentenceCheck = (str, num, char = "") =>
  str?.length > num ? str.substring(0, num) + char : str;
